import React from 'react';
const LazyDatepickerControl = React.lazy(() => import("./DatePickerControl"));
export { LazyDatepickerControl };
